module.exports = __webpack_public_path__ + "img/15.f2438696.png";